import { InfiniteScroll } from "@/components/utils/InfiniteScroll";
import { ReactNode, useMemo } from "react";
import { useAppStore } from "@/common/store/appStore";
import { useFeedStore } from "@/common/store/useFeedStore";

type IProps = {
  fetchMore: () => void | Promise<void>;
  hasMore: boolean;
  children: ReactNode;
};

export const InfinitePlayerScroll = ({ fetchMore, hasMore, children }: IProps) => {
  const isFullScreen = useAppStore((state) => state.isFullScreen);
  const isV2HeaderEnabled = useFeedStore((state) => state.isV2HeaderEnabled);

  const root = useMemo(() => {
    if (isFullScreen || isV2HeaderEnabled) {
      return ".previewFeed";
    }
  }, [isFullScreen, isV2HeaderEnabled]);

  return (
    <InfiniteScroll fetchMore={fetchMore} hasMore={hasMore} root={root}>{children}</InfiniteScroll>
  );
};
